import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { PriceData } from "./PriceData";

export default function PriceTabs() {
  const location = useLocation();
  const [activeBox, setActiveBox] = useState(null);

  useEffect(() => {
    const pathname = location.pathname;
    const activeBoxId = PriceData.find((pricebox) => pricebox.url === pathname)?.id;
    if (activeBoxId) {
      setActiveBox(activeBoxId);
    } else {
      const defaultUrl = PriceData[0]?.url;
      setActiveBox(PriceData[0]?.id); // Set the active tab to the first tab
      if (defaultUrl) {
        window.history.replaceState({}, document.title, defaultUrl);
      }
    }
  }, [location.pathname]);

  return (
    <section className="price-tabmain">
      <div className="Innerpage-title">
        <h1 className="title1 box-default pricetab text-center">Pricing</h1>
      </div>
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <div className="priceitem-tab box-default d-flex align-items-center justify-content-center">
            {PriceData.map((pricebox, index) => (
              <div className="priceitem" key={pricebox.id}>
                <Link
                  to={pricebox.url}
                  className={`price-box wow fadeIn position-relative ${
                    activeBox === pricebox.id ? "active" : ""
                  }`}
                  data-wow-duration="1s"
                  data-wow-delay={`${0.5 * (index + 1)}s`}
                >
                  <img src={pricebox.img} alt={pricebox.title} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
